import { PriceAndAvailabilityFilters } from './models/price-and-availability-filters.model';
import { PriceAndAvailability } from './models/price-and-availability.model';

export interface PriceAndAvailabilityState {
  priceAndAvailability: PriceAndAvailability[];
  filteredPriceAndAvailability: PriceAndAvailability[];
  filters: PriceAndAvailabilityFilters;
  currentPage: number;
  pageSize: number;
  totalCount: number;
  sortBy: string;
  isSortAsc: boolean;
  loading: boolean;
  error: string | null;
}

export const initialState: PriceAndAvailabilityState = {
  priceAndAvailability: [],
  filteredPriceAndAvailability: [],
  filters: {
    searchTerm: '',
    selectedCountries: [],
    isEma: false,
    isNational: false,
  },
  currentPage: 1,
  pageSize: 20,
  totalCount: 0,
  sortBy: '',
  isSortAsc: true,
  loading: false,
  error: null,
};
